import "./jrpg.css";

/**
 * The pixel field behind the JRPG skin's windows: sky, mountains, ground, and
 * the player facing a slime on the horizon. Pure decoration — no state, and the
 * sky follows `<html data-sky-theme>` in CSS.
 */
export function FieldScene() {
  return (
    <div className="jrpg-field" aria-hidden>
      <div className="jrpg-stars" />
      <div className="jrpg-sun" />
      <div className="jrpg-cloud" style={{ top: "14%", left: "12%", width: 60 }} />
      <div className="jrpg-cloud" style={{ top: "22%", left: "48%", width: 44 }} />
      <div className="jrpg-mountain" style={{ left: "4%", borderWidth: "0 110px 90px 110px" }} />
      <div className="jrpg-mountain" style={{ left: "18%", borderWidth: "0 150px 130px 150px", borderBottomColor: "#46559a" }} />
      <div className="jrpg-mountain" style={{ right: "6%", borderWidth: "0 120px 100px 120px" }} />
      <div className="jrpg-ground" />
      <Sprite who="slime" map={SLIME} />
      <Sprite who="hero" map={HERO} />
    </div>
  );
}

/* Original 16×16 sprites, one character per pixel; `.` is transparent. */
const HERO = [
  "......7777......",
  "....77777777....",
  "....7111111.....",
  "...71155151.....",
  "...71111111.....",
  "....111111......",
  "...2222222223...",
  "..222222222233..",
  "..1222222221.3..",
  "..1222222221.3..",
  "....2222222..3..",
  "....4444444.....",
  "....44...44.....",
  "....44...44.....",
  "...555...555....",
  "................",
];
const SLIME = [
  "................",
  "................",
  "......8888......",
  "....88888888....",
  "...8889888988...",
  "..888999889988..",
  "..888899888998..",
  ".88888888888888.",
  ".88866888866888.",
  ".88888888888888.",
  "8888888888888888",
  "8888888888888888",
  ".88888888888888.",
  "..888888888888..",
  "................",
  "................",
];
const PALETTE: Record<string, string> = {
  "1": "#ffd0a0",
  "2": "#2a6ad8",
  "3": "#d8d8e8",
  "4": "#5a3a20",
  "5": "#3a2410",
  "6": "#ffffff",
  "7": "#3a2410",
  "8": "#4ad04a",
  "9": "#1a5a1a",
};

function Sprite({ who, map }: { who: "hero" | "slime"; map: readonly string[] }) {
  return (
    <svg className="jrpg-sprite" data-who={who} viewBox="0 0 16 16" shapeRendering="crispEdges">
      {map.flatMap((row, y) =>
        [...row].map((pixel, x) =>
          PALETTE[pixel] ? <rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} fill={PALETTE[pixel]} /> : null,
        ),
      )}
    </svg>
  );
}
